const host = location.host
export const reg = /pbf\.winbaoxian\.com/.test(host)
export const uat = /pbf-uat\.winbaoxian\.cn/.test(host)
const domainAt = reg ? 'com' : 'cn'
export const baseUrl = (reg ? location.protocol : 'https:') + '//' + (uat ? 'planbook-uat' : 'app') + '.winbaoxian.' + domainAt
export const wyinsUrl = 'https://bxgjtc.wyins.net' + (reg ? '' : '.cn')
export const baseUrlMap = {
  'tool-api': 'https://tool-api.winbaoxian.' + domainAt,
  'interaction-api': 'https://interaction-api.winbaoxian.' + domainAt,
  'client-winbaoxian': 'https://client.winbaoxian.' + domainAt
}
export const pbfUrl = /localhost/.test(host) || /192/.test(host) ? 'http://pbf.winbaoxian.cn' : location.origin

export const API_LIST = [
  // [<接口名称, 必填>, <接口路径, 必填>, <请求方式, 可选。post | get>, <是否显示loadding, 可选>, <域名, 可选>]
  ['getCompanyList', '/planBook/common/companyList'],
  ['saveWxClient', '/planBook/CClient/saveWxClient', 'post'],
  ['saveOperate', '/planBook/CClient/operate/save', 'post'],
  ['getResult', 'result', 'get', true],
  ['visitTs', '/planBook/visitTimesStat'],
  ['clause', '/planBook/V2/result/clause', 'get', true],
  ['resultMultiple', 'resultMultiple', 'get', true],
  ['initInterest', 'initInterest'],
  ['isWechatGroup', '/planBook/V2/isWechatGroup'],
  ['queryAdvert', '/planBook/queryAdvert', 'post', true],
  ['getInterest', 'getInterest', 'post'],
  ['preview', 'manualLiability', 'post'],
  ['getMembers', '/planBook/family/member/list', 'get', true],
  ['liabilities', '/planBook/clauses', 'get', true],
  ['diseaseListV2', '/planBook/disease/getResultCategory', 'get'],
  ['diseaseV2', '/planBook/disease/getDiseaseInfoByInsurance', 'get'],
  // ['getFamilyResult', '/planBook/family/resultData'],
  ['saveHumanPath', '/planBook/humanPath/save'],
  ['getFamilyResult', '/planBook/insurePlan/resultData', 'get', true],
  // ['getMultiResult', '/planBook/MultiplayerInsure/resultData', 'get', true],
  ['getMultiResult', '/planBook/family/resultData', 'get', true],
  ['getPbCompareResult', '/planBook/pbCompare/result', 'post', true],
  ['addPbCount', 'addPbCount'],
  ['exportPlanData', '/planBook/insurePlan/exportPlanData', 'get', true],
  ['compareMission', '/planBook/V2/compareMission'],
  ['abTestForMultiGroup', '/planBook/V2/abTestForMultiGroup'],
  ['diseaseCompare', '/planBook/disease/compare'],
  ['diseaseDetail', '/planBook/disease/detail/'],
  ['multiCompare', '/planBook/disease/export/multiCompare'],
  ['getResultCategory', '/planBook/disease/getResultCategory'],
  ['getInsuranceCategory', '/planBook/disease/getInsuranceCategory'],
  ['compareByCategory', '/planBook/disease/compareByCategory'],
  ['getChunYun', '/planBook/V2/getChunYun'],
  // ['getBeneficiary', '/planBook/insurePlan/insurance/getBeneficiary'],
  ['getCompany', '/planBook/common/getCompany'],
  ['getUser', '/planBook/common/currentUser', 'get', true],
  ['createByExample', '/planBook/family/createByExample', 'post'],
  ['getClientInfo', '/planBook/CClient/getClientInfo'],
  ['getAllCondition', '/planBook/insurance/allCondition'],
  ['setShareName', '/planBook/family/v2/setShareName'],
  ['getCard', '/planBook/common/card'],
  ['getNewCard', '/planBook/common/newCard'],
  ['clauseSwitch', '/planBook/common/clauseSwitch'],
  ['getRenewRateList', '/planBook/V2/getRenewRateList', 'get', true],
  ['completeMission', '/planBook/V2/completeMission', 'post'],
  ['nameExplain', '/planBook/result/nameExplain', 'post'],
  ['signPopup', '/planBook/tag/user/sign/popup'],
  ['haveRecommend', '/planBook/result/haveRecommend', 'post'],
  [
    'addFamilyPlanbook',
    '/requirementAnalysis/addFamilyPlanbook',
    'post',
    true,
    'tool-api'
  ],
  ['getAccountRateList', 'getAccountRateList'],
  ['getVideoList', '/planBook/video/v2/getVideoList'],
  [
    'updatePBProductVideoTypeInfo',
    '/planBook/video/v2/updatePBProductVideoTypeInfo',
    'post'
  ],
  [
    'isTestUser',
    '/interactionCommon/isTestUser',
    'get',
    false,
    'interaction-api'
  ],
  [
    'wxClientSaveOperate',
    '/wxClient/saveOperate',
    'post',
    false,
    'client-winbaoxian'
  ],
  [
    'createGroup',
    '/interactionDirectCall/createGroup',
    'get',
    true,
    'interaction-api'
  ],
  [
    'pollingListAvailableGroups',
    '/interactionDirectCall/pollingListAvailableGroups',
    'get',
    false,
    'interaction-api'
  ],
  ['modifyAAT', '/planBook/result/interest/modifyAAT', 'post', true],
  ['validateAAT', '/planBook/result/interest/validateAAT', 'post', true],
  ['getInterestDetail', '/planBook/V2/interest/detail', 'post'],
  ['resultShare', '/planBook/result/share'],
  ['getApplicationInfo', '/planBook/common/getApplicationInfo'],
  ['pbCompare', '/planBook/pbCompare', 'post'],
  [
    'getRecords',
    '/interationRecord/getRecords',
    'post',
    true,
    'interaction-api'
  ],
  [
    'saveVersionNum',
    '/interationRecord/saveVersionNum',
    'get',
    false,
    'interaction-api'
  ],
  [
    'policyInfo',
    '/planBook/insurePlan/v2/policyInfo',
    'get',
    true
  ],
  [
    'sendAudio',
    'sendAudio',
    'get',
    true
  ],
  ['getIrrInfo', 'getIrrInfo', 'post', true],
  // PbPublic
  ['getPublicResult', '/planBook/public/result', 'get', true],
  ['getPublicClause', '/planBook/public/result/clause'],
  ['initPublicInterest', '/planBook/public/result/initInterest'],
  ['getPublicInterest', '/planBook/public/result/getInterest', 'post'],
  ['pbCompareShare', '/planBook/pbCompare/share'],
  ['getExportOption', '/planBook/result/export/option'],
  ['getTermParseMindmap', '/planBook/insurance/clause/mindMap', true]
]